import { Link } from 'react-router-dom';
import SectionLink from './SectionLink';

function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-300 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Column 1 - Logo & Copyright */}
          <div>
            <div className="flex items-center space-x-2 mb-2">
              <img
                src="/logo.png"
                alt="One Stop Greek Logo"
                className="h-8 w-8"
              />
              <h3 className="font-bold text-white text-lg">
                One Stop Greek
              </h3>
            </div>
            <p className="text-sm mt-2">
              © {new Date().getFullYear()} All rights reserved.
            </p>
          </div>

          {/* Column 2 - Product.
              Features and Pricing go through SectionLink: a bare '#features'
              anchor resolves against the current path, so on /contact and
              /privacy-policy it addressed a section that page does not have.
              Download, About and Team were buttons with no handler and are
              gone rather than pointing at a page that does not exist. */}
          <div>
            <h4 className="font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-2">
              <li>
                <SectionLink id="features" className="hover:text-white transition">
                  Features
                </SectionLink>
              </li>
              <li>
                <SectionLink id="pricing" className="hover:text-white transition">
                  Pricing
                </SectionLink>
              </li>
            </ul>
          </div>

          {/* Column 3 - Company */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="hover:text-white transition">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Legal */}
          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="hover:text-white transition">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
